module.exports = __webpack_public_path__ + "static/media/alifian_aji_s.0836683b.jpg";